import { Badge } from "@coval/ui"

import type { CoviActionItem, SofiaProposedAction } from "../model/types"
import { parseActionArgs } from "../utils/actions"

export function DraftTestCasesSummary({
  proposal,
  status,
}: {
  proposal: SofiaProposedAction
  status: CoviActionItem["status"]
}) {
  const parsed = parseActionArgs(proposal)
  if (
    !parsed.ok ||
    (parsed.action.kind !== "draft_test_cases" &&
      parsed.action.kind !== "create_test_set")
  ) {
    return null
  }
  const cases = parsed.action.args.test_cases
  if (!cases?.length) {
    return null
  }
  const combined = parsed.action.kind === "create_test_set"
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-2">
        <h4 className="text-sm font-medium text-coval-text">
          {cases.length} Test {cases.length === 1 ? "Case" : "Cases"}
        </h4>
        <Badge variant="default" className="text-xs">
          {status === "done"
            ? combined
              ? "CREATED"
              : "STAGED"
            : status === "dismissed"
              ? "DISMISSED"
              : "DRAFT"}
        </Badge>
      </div>
      {status !== "done" && status !== "dismissed" ? (
        <p className="text-xs text-coval-text-muted">
          {combined
            ? "These cases will be created with your test set."
            : "Review these drafts in the editor, then save them to this test set."}
        </p>
      ) : null}
      <ol className="list-decimal space-y-3 pl-5 text-sm text-coval-text">
        {cases.map((testCase, index) => (
          <li key={index} className="pl-1">
            <p className="whitespace-pre-wrap break-words">
              {testCase.description || testCase.input_str}
            </p>
            {testCase.description &&
            testCase.input_str &&
            testCase.description !== testCase.input_str ? (
              <p className="mt-1 whitespace-pre-wrap break-words text-xs leading-relaxed text-coval-text-muted">
                {testCase.input_str}
              </p>
            ) : null}
          </li>
        ))}
      </ol>
    </div>
  )
}
